"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const video_client_core_1 = require("@video/video-client-core");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const PillToggle_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/PillToggle"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const LowLatencyToggle = (0, mobx_react_lite_1.observer)(({ classes = {}, disableToggle, active, ...props }) => {
    const componentName = "<LowLatencyToggle/>";
    /**
     * Access PlayerUiContext.
     */
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.player) != null, componentName);
    const handleClick = () => {
        if (ctx.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR)) {
            ctx.player.lowLatency = !ctx.player.lowLatency;
        }
    };
    const hideToggle = () => {
        var _a, _b;
        // Hide if not player selector
        if (!ctx.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR)) {
            return true;
        }
        // Hide if player selector, but doesn't support lowLatency (i.e. no webrtc available)
        if (ctx.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR) && !((_a = ctx.player) === null || _a === void 0 ? void 0 : _a.supportsLowLatency)) {
            return true;
        }
        // Hide if player selector supports lowLatency but not able to fallback
        if (ctx.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR) &&
            ((_b = ctx.player) === null || _b === void 0 ? void 0 : _b.supportsLowLatency) &&
            ctx.player.availablePlayers.length <= 1) {
            return true;
        }
        return false;
    };
    if (hideToggle()) {
        return null;
    }
    return (react_1.default.createElement(PillToggle_1.default
    // disabledOff={disableToggle} // Idk what disabledOn/disabledOff is for specifically, should prob be refactored to just disabled
    , { 
        // disabledOff={disableToggle} // Idk what disabledOn/disabledOff is for specifically, should prob be refactored to just disabled
        isActive: ctx.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR) && ctx.player.lowLatency, label: "Low-latency:", handleClick: handleClick, ...props }));
});
function LowLatencyToggleWithErrorBoundary({ classes, ...props }) {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(PillToggle_1.default, { isActive: false, disabled: true, ...props }) },
        react_1.default.createElement(LowLatencyToggle, { ...props })));
}
exports.default = LowLatencyToggleWithErrorBoundary;
//# sourceMappingURL=LowLatencyToggle.js.map